import type { INotificationBannerIcon, NotificationStatusType } from './helpers';

export const NotificationBannerAlertIcon = ({ status, ...props }: INotificationBannerIcon) => {
	const fillObject: Record<NotificationStatusType, string> = {
		error: '#C11F1E',
		warning: '#C47F09',
		success: '#1AA551',
	};

	const fill = fillObject[status ?? 'success'];

	return (
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.5063 2.47278C10.4083 2.10728 10.1333 1.81578 9.7748 1.69628C9.4163 1.57678 9.0213 1.64578 8.7243 1.87928C7.1053 3.15178 3.85381 5.70728 3.85381 5.70728C3.73581 5.80028 3.68431 5.95428 3.72331 6.09928L4.72031 9.81978C4.75881 9.96478 4.88031 10.0728 5.02881 10.0938C5.02881 10.0938 9.1228 10.6813 11.1613 10.9738C11.5353 11.0278 11.9113 10.8898 12.1623 10.6068C12.4133 10.3243 12.5053 9.93428 12.4078 9.56928C11.9283 7.78128 10.9853 4.26078 10.5063 2.47278ZM9.7818 2.66678C10.2608 4.45478 11.2038 7.97528 11.6833 9.76328C11.7158 9.88478 11.6853 10.0148 11.6013 10.1093C11.5178 10.2033 11.3923 10.2493 11.2678 10.2313L5.38031 9.38678L4.51181 6.14428L9.1878 2.46878C9.2868 2.39128 9.4183 2.36828 9.53781 2.40778C9.65731 2.44778 9.7488 2.54478 9.7818 2.66678Z'
				fill={fill}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M4.44781 5.90526C4.39381 5.70526 4.18831 5.58626 3.98831 5.63976C3.98831 5.63976 3.05481 5.89026 2.29431 6.09376C1.94181 6.18826 1.64131 6.41876 1.45931 6.73476C1.27681 7.05026 1.22731 7.42576 1.32181 7.77776C1.46931 8.32826 1.65331 9.01626 1.80081 9.56676C1.89531 9.91876 2.12581 10.2193 2.44181 10.4013C2.75731 10.5838 3.13281 10.6333 3.48531 10.5388C4.24581 10.3348 5.17931 10.0848 5.17931 10.0848C5.37931 10.0313 5.49831 9.82576 5.44431 9.62576L4.44781 5.90526ZM3.82031 6.46126L4.62281 9.45726L3.29081 9.81426C3.13081 9.85726 2.96031 9.83476 2.81681 9.75176C2.67331 9.66926 2.56831 9.53276 2.52531 9.37226L2.04631 7.58376C2.00331 7.42376 2.02581 7.25326 2.10881 7.10976C2.19131 6.96626 2.32831 6.86126 2.48831 6.81826L3.82031 6.46126Z'
				fill={fill}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5.75415 9.44037C5.62915 9.42237 5.50365 9.46837 5.42015 9.56237C5.33665 9.65687 5.30565 9.78687 5.33865 9.90837L5.83365 11.7569C5.88415 11.9449 6.06965 12.0629 6.26165 12.0289C6.31115 12.0204 6.36065 12.0094 6.41065 11.9959C7.30415 11.7564 7.85215 10.8694 7.68615 9.97487C7.65665 9.81687 7.52965 9.69487 7.37065 9.67237L5.75415 9.44037ZM6.45415 11.1739L6.21015 10.2634L6.96265 10.3714C6.93765 10.7044 6.74715 11.0079 6.45415 11.1739Z'
				fill={fill}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M6.0627 9.71433C6.0242 9.56933 5.9027 9.46133 5.7542 9.44033L5.1362 9.35133C5.0857 9.34433 5.0347 9.34733 4.9857 9.36033L3.6797 9.71033C3.5762 9.73833 3.4897 9.80883 3.4417 9.90433C3.3937 10.0003 3.3887 10.1118 3.4287 10.2113C3.4287 10.2113 4.2752 12.3363 4.7057 13.4183C4.9162 13.9468 5.4892 14.2343 6.0387 14.0868C6.6552 13.9218 7.0207 13.2883 6.8557 12.6723L6.0627 9.71433ZM5.4027 10.1473L6.1312 12.8663C6.1892 13.0823 6.0607 13.3043 5.8447 13.3623C5.6622 13.4113 5.4722 13.3163 5.4027 13.1408L4.2812 10.3258L5.1057 10.1048L5.4027 10.1473Z'
				fill={fill}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M14.408 4.97179L12.9575 5.36079C12.7575 5.41429 12.639 5.61979 12.6925 5.81979C12.746 6.01979 12.952 6.13879 13.1515 6.08479L14.602 5.69629C14.802 5.64279 14.921 5.43679 14.8675 5.23729C14.8135 5.03729 14.608 4.91829 14.408 4.97179Z'
				fill={fill}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12.9508 2.24714L11.7438 3.14014C11.5773 3.26364 11.5423 3.49864 11.6653 3.66464C11.7883 3.83114 12.0233 3.86664 12.1898 3.74314L13.3968 2.85014C13.5633 2.72714 13.5983 2.49214 13.4753 2.32564C13.3523 2.15964 13.1173 2.12414 12.9508 2.24714Z'
				fill={fill}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M14.7476 8.05112L13.2586 7.85762C13.0531 7.83112 12.8651 7.97612 12.8381 8.18162C12.8116 8.38662 12.9566 8.57512 13.1621 8.60162L14.6511 8.79462C14.8561 8.82112 15.0446 8.67612 15.0711 8.47112C15.0976 8.26562 14.9526 8.07762 14.7476 8.05112Z'
				fill={fill}
			/>
		</svg>
	);
};
